import { render } from "./BroadcastEventExtrasCard.vue?vue&type=template&id=729dedad"
import script from "./BroadcastEventExtrasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastEventExtrasCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/Broadcast/BroadcastEventExtrasCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "729dedad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('729dedad', __exports__)) {
    api.reload('729dedad', __exports__)
  }
  
  module.hot.accept("./BroadcastEventExtrasCard.vue?vue&type=template&id=729dedad", () => {
    api.rerender('729dedad', render)
  })

}


export default __exports__